export const API_URL = 'api.com.studio.mpp360.tech/api';